import { useTranslation } from "react-i18next";

import CustomModal from "@components/CustomModal";
import PublishPostModal from "@components/_modals/Group/PublishPost";

import useAdminPostManage from "./hooks/useAdminPostManage";
import AdminPostManageView from "./view";

export default function AdminPostManageModal({ modalRef }) {
    const { t } = useTranslation("groupModals");
    const {
        open,
        post,
        loading,
        editModalRef,
        canManageSchedule,
        handleClose,
        handleEdit,
        handlePostNow,
        handleAddPoints,
        handleDeducePoints,
        handleDeletePost,
    } = useAdminPostManage({ modalRef });

    return (
        <>
            <CustomModal
                maxWidth={340}
                bottomButtonCancelText={t("common:actions.cancel")}
                hideSecondaryButton={false}
                loading={loading}
                title={t("adminPostManage.title")}
                handleSubmit={() => { }}
                open={open}
                handleClose={handleClose}
                width="100%"
                bodyComponent={
                    open ? (
                        <AdminPostManageView
                            post={post}
                            loading={loading}
                            canManageSchedule={canManageSchedule}
                            onEdit={handleEdit}
                            onPostNow={handlePostNow}
                            onAddPoints={handleAddPoints}
                            onDeducePoints={handleDeducePoints}
                            onDeletePost={handleDeletePost}
                        />
                    ) : null
                }
            />

            {/* Edit reopens the composer, pre-filled, once this modal has closed. */}
            <PublishPostModal modalRef={editModalRef} />
        </>
    );
}
